// extracted by mini-css-extract-plugin
export default {"root":"iiWOSya7blvfHKlSpCYz","contentWrapper":"are6xGCrkwvkzNqt_8RI"};